import { LineupSurveyDetail as LineupSurveyDetailComponent } from './LineupSurveyDetail.component';
import { connector } from './LineupSurveyDetail.connector';

export const LineupSurveyDetail = connector(LineupSurveyDetailComponent);
